import React, { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import type { Region } from 'app/api/services/site-configs/types';

import { SELECTED_REGION } from 'app/constants/cookieKeys';
import { Icon, IconSize } from 'app/design-system/components/Icon';
import { useTranslation } from 'app/lang';
import { isMultiDomain } from 'app/lib/site-configs/selectors';
import { cookie } from 'app/packages/lib';

import { getRegionTitle } from './get-region-title';

import styles from './RegionItem.module.scss';

type RegionItemProps = {
  region: Region;
  currentRegion?: string;
  onClose: VoidFunction;
};

const RegionItem: FC<RegionItemProps> = ({
  region,
  currentRegion,
  onClose,
}) => {
  const isRegionActive = currentRegion === region.id;
  const { lang } = useTranslation();
  const isMulti = useSelector(isMultiDomain);
  const regionTitle = getRegionTitle(lang, region.title);
  const _className = classNames(styles.link, { [styles.active]: isRegionActive });

  const clickHandler = useCallback(() => {
    if (isMulti) {
      return;
    }
    cookie.setCookie(SELECTED_REGION, region.id);
    onClose();
  }, [isMulti, region.id]);

  const listItem = (
    <>
      {isRegionActive && (
        <Icon icon="check"
              size={IconSize.MEDIUM} />
      )}
      {regionTitle}
    </>
  );

  return (
    <li className={styles.root}>
      {isMulti ? (
        <a href={region.domain}
           className={_className}>
          {listItem}
        </a>
      ) : (
        <button className={_className}
                type="button"
                onClick={clickHandler}>
          {listItem}
        </button>
      )}
    </li>
  );
};

export default RegionItem;
